export default "__VITE_ASSET__Cc$$5zNI__"